module.exports = __webpack_public_path__ + "static/img/frank-busch-PzifgmBsxCc-unsplash_thumb.87b4094.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/ads/standard_bg/frank-busch-PzifgmBsxCc-unsplash_thumb.png
// module id = OzAH
// module chunks = 4